import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import * as Cookies from 'js-cookie';
import { MessageProvider } from '../../../contexts/MessageContext';
import { EmitPage } from '../../Analytics/VisibilityPixel/VisibilityPixel';
import Header from '../Header/Header';
import './Layout.scss';
import TopBannerController from '../TopBannerController/TopBannerController';
import { FOOTER_TYPES, socialIcons } from '../Footer/constants';
import { PageContext } from '../../../contexts/ContextCreator';
import { serializeHeaderProps } from '../utils';
import { CookiesBanner } from '../CookieBanner/CookieBannerV2';
import { PAGE_PROPS as DEFAULT_PAGE_PROPS } from '../../../pages/defaultProps';
import { Footer } from '../Footer/DesktopFooter/DesktopFooterV2/DesktopFooterV2';

export default class Layout extends React.Component {
    /**
     * You should define any and all default props here
     * @type {{children: XML}}
     */
    constructor(props) {
        super(props);
        this.state = {
            hasCookie: false,
        };
        this.baseClassName = 'component-Layout';
    }

    componentDidMount() {
        EmitPage();
        this.setCookies();
    }

    setCookies = () => {
        const cookieName = 'FGBAllowCookies';
        const hasCookie = Cookies.get(cookieName);
        this.setState({ hasCookie });
    };

    setCookieYes = () => {
        Cookies.set('FGBAllowCookies', '1', { expires: 1095 });
        if (!this.context?.leadInLogin) {
            window.location.reload();
        } else {
            this.setCookies();
        }
    };

    render() {
        const {
            PAGE_PROPS,
            displayDesktopFooter,
            children,
            className,
            topBannerOnlyShownList,
        } = this.props;
        const { hasCookie } = this.state;
        const stickyFooterCssClass = displayDesktopFooter
            ? 'layout-sticky-footer'
            : '';
        const serializedHeaderProps = serializeHeaderProps({
            ...this.context,
            footerType: FOOTER_TYPES.DRAWER_FOOTER,
            socialIcons,
        });

        return (
            <div
                className={`${this.baseClassName} ${className} fullScreen ${stickyFooterCssClass}`}
            >
                <MessageProvider
                    PAGE_PROPS={PAGE_PROPS}
                    messageTypes={['community-user-message']}
                    getUserStatus={this.context.getUserStatus}
                    autoInitChat={false}
                    setNextChannelAsCurrent={false}
                >
                    <Header {...serializedHeaderProps} />

                    <TopBannerController
                        topBannerOnlyShownList={topBannerOnlyShownList}
                        adminOnboardingProps={this.props.adminOnboardingProps}
                        pageDisplayMode={this.context.pageDisplayMode}
                    />

                    {/** DO NOT REMOVE, hack for error placement of dom element on job activity page with job profile */}
                    <span />

                    <div className={`${this.baseClassName}__content-wrapper`}>
                        {children}
                    </div>

                    {displayDesktopFooter && <Footer />}
                    {!hasCookie && (
                        <CookiesBanner
                            acceptCookies={this.setCookieYes}
                            closeBanner={this.setCookieYes}
                        />
                    )}

                    <NoSSR>
                        <div
                            style={{ display: 'none' }}
                            data-qa-attr="jsIsReady"
                        >
                            JS Ready!
                        </div>
                    </NoSSR>
                </MessageProvider>
            </div>
        );
    }
}

Layout.defaultProps = {
    PAGE_PROPS: { url: { path: '/' } },
    displayDesktopFooter: true,
    className: '',
    topBannerOnlyShownList: [],
    adminOnboardingProps: {},
};

Layout.propTypes = {
    /**
     * global page props
     */
    PAGE_PROPS: DEFAULT_PAGE_PROPS,
    /**
     * additional styling
     */
    className: PropTypes.string,
    /**
     * The Child components to be the content of the layout
     */
    children: PropTypes.node.isRequired,
    /**
     * whether displaying or hidding desktop footer
     */
    displayDesktopFooter: PropTypes.bool,
    /**
     * list of existing top banner that should be only shown in
     */
    topBannerOnlyShownList: PropTypes.arrayOf(
        PropTypes.oneOf([
            'profile-cta',
            'admin-onboard',
            'job-seeker-profile',
            'ann-taylor-community',
        ])
    ),
    /**
     * props required by admin onboarding banner
     */
    adminOnboardingProps: PropTypes.shape({
        showBanner: PropTypes.bool,
    }),
};

Layout.contextType = PageContext;
